import * as z from 'zod';

export const entityNameSchema = z
  .object({
    corporationName: z
      .string()
      .trim()
      .min(1, { message: 'Corporation name should not be empty.' }),
    companyLegalName2: z
      .string()
      .trim()
      .min(1, { message: 'Corporation name should not be empty.' }),
    companyLegalName3: z
      .string()
      .trim()
      .min(1, { message: 'Corporation name should not be empty.' }),
    hasTranslation: z.boolean().default(false),
    translatedCorporationName: z.string().trim().nullable().optional(),
    translatedCompanyLegalName2: z.string().trim().nullable().optional(),
    translatedCompanyLegalName3: z.string().trim().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.hasTranslation) {
      if (!data.translatedCorporationName?.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Translated corporation name should not be empty.',
          path: ['translatedCorporationName'],
        });
      }
      if (!data.translatedCompanyLegalName2?.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Translated corporation name should not be empty.',
          path: ['translatedCompanyLegalName2'],
        });
      }
      if (!data.translatedCompanyLegalName3?.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Translated corporation name should not be empty.',
          path: ['translatedCompanyLegalName3'],
        });
      }
    }
  });

export type TEntityNameFields = z.infer<typeof entityNameSchema>;
